import React from 'react';
import styled from 'styled-components';

interface ModernButtonProps {
  children: React.ReactNode;
  className?: string;
  as?: React.ElementType;
  to?: string;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'ghost';
}

const ButtonWrapper = styled.div<{ $variant: string }>`
  display: inline-block;
  position: relative;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ $variant }) => 
      $variant === 'primary' ? 'var(--shadow-md)' : 
      $variant === 'secondary' ? 'var(--shadow-sm)' : 
      'none'
    };
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const ModernButton: React.FC<ModernButtonProps> = ({ 
  children, 
  className = '', 
  variant = 'primary',
  as = 'button',
  ...props 
}) => {
  const Component = as;

  return (
    <ButtonWrapper 
      className={className}
      $variant={variant}
    >
      <Component {...props}>
        {children}
      </Component>
    </ButtonWrapper>
  );
};

export default ModernButton;